// mixin for the deal customize page

import { mapGetters, mapActions, mapMutations } from 'vuex'
import image from '../products/image'
import { halfNHalfItem } from '../../utils/const'
import hnhImg from '../../../common/assets/half-half.png'

export default function (mode = 'default') {
  let getters = [
    'configItemPrice',
    'products',
    'currentItem',
    'activeProduct',
    'toppingList',
    'freePizzaRewardDeal',
    'availableLoyaltyPoints',
    'currentStore',
    'bases'
  ]
  if (mode === 'pos') {
    getters = [
      'configItemPrice', 
      'products', 
      'currentItem', 
      'activeProduct', 
      'toppingList', 
      'freePizzaRewardDeal', 
      'activeChild', 
      'parentProduct',
      'bases'
    ]
  }
  return {
    mixins: [image],
    data () {
      return {
        dealSelectionIds: [],
        dealSelection: [],
        hnhImg,
        selectedSize: null
      }
    },
    mounted () {
      setTimeout(() => {
        if (!this.currentItem.products) { // the deal is empty
          for (let i = 0; i < this.dealOptions.length; i++) {
            if (this.dealOptions[i].items.length === 1) {
              this.dealSelectionIds.push(this.dealOptions[i].items[0].id)
              this.dealSelection.push(this.dealOptions[i].items[0])
            } else {
              this.dealSelectionIds.push(null)
              this.dealSelection.push(null)
            }
          } // prefill the options
        } else {
          this.dealSelectionIds = this.currentItem.products.map(product => product ? product.id : null) // assign the selection
          this.dealSelection = this.currentItem.products
        }
      }, 10)
    },
    computed: {
      ...mapGetters(getters),
      image () {
        if (this.product) {
          const asset = this.currentItem.assets.filter(asset => asset.position === 'banner')[0]
          return asset ? asset.path : false
        }
        return false
      },
      activeSize () {
        if (this.currentItem && this.currentItem.selectedSize) {
          return this.currentItem.sizes.findIndex(size => size.size === this.currentItem.selectedSize.size)
        }
        return null
      },
      dealOptions () {
        const products = JSON.parse(JSON.stringify(this.products))
        const selectedSize = this.currentItem.selectedSize ? this.currentItem.selectedSize.size : null
        return this.currentItem.items.map(item => {
          const settings = item.settings
          let items = []
          switch (settings.type) {
            case 'product_type':
              const group = Object.values(products).filter(group => group.product_type_id === parseInt(settings.product_type))[0]
              if (group.product_type_name === 'pizza') {
                if (group.items.filter(item => item.id === -1).length === 0 && this.$platform !== 'pos') {
                  group.items.push(Object.assign({}, halfNHalfItem))
                }
              }
              group.items = group.items.sort(this.compareForSorting)
              if (selectedSize && group.product_type_name === 'pizza') {
                group.items = group.items.filter((item) => {
                  return (item.product_type === 'pizza' && item.sizes.map(size => size.size).includes(selectedSize)) || (item.id === -1 && selectedSize !== 'small')
                })
              }

              // Set the size to the one set in the admin
              if (group.product_type_name !== 'pizza') {
                group.items = group.items.filter((item) => {
                  if (!settings.alcohol && item.tags.includes('alcohol')) {
                    return false;
                  }
                  return item.sizes.map(size => size.size_id).includes(parseInt(settings.size))
                })

                group.items = group.items.map((item) => {
                  item.selectedSize = item.sizes.filter(size => size.size_id === parseInt(settings.size))[0]

                  return item
                })
              }

              return group
            case 'list':
              const deal_items = JSON.parse(JSON.parse(JSON.stringify(settings.deal_items))).map(id => parseInt(id))
              items = Object.values(products).map(group => group.items).flat().filter(product => deal_items.includes(product.id))
              items = items.map((item) => {
                item.selectedSize = {size: settings.size, customSize: true}
                return item
              })

              items.sort(this.compareForSorting)
              return { product_type_name: 'product', items }
            case 'product':
              items = Object.values(products).map(group => group.items).flat().filter(product => product.id === parseInt(settings.deal_item))
              items.sort(this.compareForSorting)
              items = items.map((item) => {
                item.selectedSize = {size: settings.size, customSize: true}
                return item
              })

              if (item) {
                return { product_type_name: 'product', items }
              } else {
                return false
              }
            default:
              return false
          }
        }).filter(item => item.items.length).map(item => {
          item.items = item.items.map(item => {
            const product = Object.assign(item, { showSize: false, showBase: true })// do not modify the menu
            if (product.sizes && Array.isArray(product.sizes)) { // set the size to child products the same as the deal
              if (this.currentItem.selectedSize && !this.currentItem.selectedSize.customSize) {
                const size = product.sizes.filter(size => size.size === this.currentItem.selectedSize.size)[0]

                if (size) {
                  product.selectedSize = product.sizes.filter(size => size.size === this.currentItem.selectedSize.size)[0]
                }
              }
            }
            return product
          })
          return item
        }) // only the valid options
      },
      disabledSave () {
        return this.dealSelectionIds.filter(item => item === null).length !== 0
      }
    },
    methods: {
      ...mapActions(['setSize', 'setCurrentItem']),
      ...mapMutations(['setCustomizedActiveChild', 'initCurrentItemProducts']),
      resetSelectedProduct () {
        // We need to empty out the selected product on deal size change if the selected product (child) is not available in that size.
        // We simply empty it in dealSelectionIds and dealSelection array.
        const selectedSize = this.currentItem ? (this.currentItem.selectedSize ? this.currentItem.selectedSize.size : null ) : null
        if (this.dealSelectionIds.length && selectedSize) {
          this.dealSelectionIds = this.dealSelectionIds.map((id, index) => {
            if (!id) {
              return null
            }
            if (id && this.dealOptions[index].items.length) {
              const itemFound = this.dealOptions[index].items.find(item => item.id === id)
              if (itemFound) {
                if (itemFound.product_type === 'pizza') {
                  if (itemFound.sizes.map(size => size.size).includes(selectedSize)) {
                    return id
                  }
                  this.dealSelection[index] = null
                  this.setCurrentItem({ idx: [index], product:  this.dealSelection[index] })
                  return null
                }
                return id
              }
            }
            this.dealSelection[index] = null
            this.setCurrentItem({ idx: [index], product:  this.dealSelection[index] })
            return null
          })
        }
      },
      setDealSize (data) {
        this.setSize(data)
        this.resetSelectedProduct()
      },
      initializeCurrentProductItems () {
        // The currentItem.products is false when we open it first.
        // When we add first item into it, it initializes with the pre-selected items.
        const products = this.dealSelectionIds.map((id, index) => {
          if (id) {
            const product = this.dealOptions[index].items.find(item => item.id === id)
            if (product) {
              if (product.id === -1) {
                product.selectedSize = this.currentItem.selectedSize
              }
              Object.assign(product, { preselected: true })
              this.setSelectedBase(product)
              return product
            }
          }
          return null
        })
        this.dealSelection = products
        this.initCurrentItemProducts(products)
      },
      dealItemSelected (idx) {
        if (!this.currentItem.products) {
          this.initializeCurrentProductItems()
        } else {
          this.dealSelection[idx] = this.dealOptions[idx].items.find(item => item.id === this.dealSelectionIds[idx])
          if (this.dealSelection[idx]) {
            if (this.dealSelection[idx].id === -1) {
              this.dealSelection[idx].selectedSize = this.currentItem.selectedSize
            }
            this.setSelectedBase(this.dealSelection[idx])
            this.setCurrentItem({ idx: [idx], product:  this.dealSelection[idx] }) // reassign a product
          }
        }
  
        if (this.dealSelection[idx] && this.dealSelection[idx].product_type === 'halfNHalf') {
          this.setCustomizedActiveChild(idx)
        }
        this.$forceUpdate()
      },
      setSelectedBase (selectedPizza) {
        if (selectedPizza.product_type === 'pizza') {
          let availableBases = JSON.parse(JSON.stringify(this.bases))
          if (Array.isArray(selectedPizza.available_ingredients) && selectedPizza.available_ingredients.length) {
            const bases = this.bases.filter(item => selectedPizza.available_ingredients.includes(item.id))
            if (bases.length === 0) {
              if (this.selectedSize) {
                availableBases = this.bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
              } else {
                availableBases = this.bases
              }
            } else {
              if (this.selectedSize) {
                availableBases = bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
              } else {
                availableBases = bases
              }
            }
          } else {
            if (this.selectedSize) {
              availableBases = this.bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize))
            } else {
              availableBases = this.bases
            }
          }
          if (selectedPizza.default_base) {
            const base = availableBases.find(base => base.id === parseInt(selectedPizza.default_base))
            if (base) {
              selectedPizza.selectedBase = base
            } else {
              selectedPizza.selectedBase = availableBases[0]
            }
          } else {
            selectedPizza.selectedBase = availableBases[0]
          }
        }
      },
      save (e = false) { // emit the event that the pizza has been customized
        this.$emit('product:save', e)
      },
      getIngredients (item) {
        if (item && item.ingredientSelection) {
          const ingredients = []
          if (item.selectedBase) {
            ingredients.push(item.selectedBase.name)
          }
          return ingredients.concat(Object.entries(item.ingredientSelection)
            .filter(item => ![false, -1, 0].includes(item[1]))
            .map(item => this.toppingList.filter(topping => topping.id === parseInt(item[0])))
            .flat()
            .map(item => item.name)).join(', ')
        } else {
          return item ? item.description : null
        }
      },
      compareForSorting(a, b) {
        let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
        if (fa < fb)
          return -1;
        if (fa > fb)
          return 1;
        return 0;
      }
    },
    watch: {
      availableLoyaltyPoints (newValue) {
        if (newValue < 1000) {
          this.redirectToLoyalty()
        }
      }
    }
  }
}